import { ComponentProps, useCallback } from 'react'
import { cn } from '~utils/cn'

import Icon from '~components/ui/icon'
import { useSelectBox } from './context'

type Props = ComponentProps<'div'> & {
  placeholder?: string
  onSearch?: (value: string) => void
}

const SelectBoxDropdownSearch = ({
  placeholder = 'Search...',
  onSearch: _onSearch,
  ...props
}: Props) => {
  const { className } = props
  const { searchValue, onSearch } = useSelectBox()

  const ref = useCallback((node: HTMLInputElement | null) => {
    node?.focus()
  }, [])

  const handleSearch = (value: string) => {
    _onSearch?.(value)
    onSearch(value)
  }

  return (
    <div
      {...props}
      className={cn(
        'relative w-full border-b border-solid border-gray-100 dark:border-gray-900',
        className
      )}
    >
      <div className="absolute left-5 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center">
        <Icon name="search" className="size-[18px] fill-gray-900 dark:fill-gray-300" />
      </div>
      <input
        ref={ref}
        value={searchValue}
        onChange={e => {
          handleSearch(e.target.value)
        }}
        placeholder={placeholder}
        className="w-full py-4 pl-[52px] pr-5 text-gray-900 outline-none text-body-1 placeholder:text-gray-400 placeholder:text-body-1 dark:placeholder:text-gray-500"
      />
    </div>
  )
}

export default SelectBoxDropdownSearch
